export const isEmpty = (text) => {
  return (text === '' || text === null)
}

const isValidPhone = (phone) => {
  // eslint-disable-next-line
  var re = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/
  return re.test(phone)
}

const isValidEmail = (email) => {
  // eslint-disable-next-line
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

// Converte caractere para valor numérico conforme IN RFB 2.229/2024:
// '0'→0 … '9'→9, 'A'→17 … 'Z'→42  (charCode - 48)
const charToValue = (ch) => ch.charCodeAt(0) - 48

export const isValidCNPJ = (cnpj) => {
  cnpj = cnpj.replace(/[^A-Z0-9]/gi, '').toUpperCase()
  if (cnpj === '') return false
  if (cnpj.length !== 14) return false

  // Estrutura: 12 posições alfanuméricas [A-Z0-9] + 2 dígitos verificadores numéricos
  if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false

  // Elimina sequências com todos os caracteres iguais (CNPJs trivialmente inválidos)
  if (/^(.)\1{13}$/.test(cnpj)) return false

  var i, sum, result
  var base = cnpj.substring(0, 12)
  var dig = cnpj.substring(12)

  // Primeiro dígito verificador (pesos: 5,4,3,2,9,8,7,6,5,4,3,2)
  var weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  sum = 0
  for (i = 0; i < 12; i++) {
    sum += charToValue(base.charAt(i)) * weights1[i]
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
  if (result !== parseInt(dig.charAt(0), 10)) return false

  // Segundo dígito verificador (pesos: 6,5,4,3,2,9,8,7,6,5,4,3,2)
  var base2 = base + dig.charAt(0)
  var weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  sum = 0
  for (i = 0; i < 13; i++) {
    sum += charToValue(base2.charAt(i)) * weights2[i]
  }
  result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
  if (result !== parseInt(dig.charAt(1), 10)) return false

  return true
}

const isValidCPF = (cpf) => {
  // eslint-disable-next-line
  cpf = cpf.replace(/[^\d]+/g,'')
  if (cpf === '') return false
  // Elimina CPFs invalidos conhecidos
  if (cpf.length !== 11 || cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' || cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' || cpf === '66666666666' || cpf === '77777777777' || cpf === '88888888888' || cpf === '99999999999') {
    return false
  }
  var add, rev, i
  // Valida 1o digito
  add = 0
  for (i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(cpf.charAt(9))) {
    return false
  }
  // Valida 2o digito
  add = 0
  for (i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(cpf.charAt(10))) {
    return false
  }
  return true
}

const toDigits = numString =>
  numString
    .replace(/[^0-9]/g, '')
    .split('')
    .map(Number)

const condTransform = (predicate, value, fn) => {
  if (predicate) {
    return fn(value)
  } else {
    return value
  }
}

const doubleEveryOther = (current, idx) =>
  condTransform(idx % 2 === 0, current, x => x * 2)

const reduceMultiDigitVals = current =>
  condTransform(current > 9, current, x => x - 9)

const isValidCard = (numString) => {
  if (!numString || numString !== '') return false
  const digits = toDigits(numString)
  const len = digits.length
  const luhnDigit = digits[len - 1]
  const total = digits
    .slice(0, -1)
    .reverse()
    .map(doubleEveryOther)
    .map(reduceMultiDigitVals)
    .reduce((current, accumulator) => current + accumulator, luhnDigit)
  return total % 10 === 0
}

const isValidExpDate = (date) => {
  const month = date.substring(0, 2)
  var year = date.substring(2, 4)
  if (!(month && year) || (month === '' || year === '')) {
    return false
  }
  if (!/^\d+$/.test(month)) {
    return false
  }
  if (!/^\d+$/.test(year)) {
    return false
  }
  if (parseInt(month, 10) > 12 || parseInt(month, 10) === 0) {
    return false
  }
  if (year.length === 2) {
    var prefix = (new Date()).getFullYear()
    prefix = prefix.toString().slice(0, 2)
    year = prefix + year
  }
  // o 0 faz retornar o último dia do mês
  const expiration = new Date(year, month, 0)
  // ajusta hora de 00:00:00 para 23:59:59
  expiration.setHours(23, 59, 59)
  const current = new Date()
  const lessThan13 = expiration.getFullYear() - current.getFullYear() <= 13
  return expiration > current && lessThan13
}

export function hasError (field) {
  var error = false

  if (!field.validation) return false

  if (field.validation.required && isEmpty(field.value)) {
    return 'required'
  }

  if (!isEmpty(field.value)) {
    if (field.validation.length) {
      const str = field.value.toString()
      if (typeof field.validation.length === 'object') {
        error = true
        field.validation.length.forEach(size => {
          if (str.length === size) {
            error = false
          }
        })
        return error ? 'length' : false
      }
      return str.length !== field.validation.length ? 'length' : false
    }

    if (field.validation.format) {
      field.validation.format.forEach(format => {
        if (format.type === 'email') {
          error = !isValidEmail(field.value)
        }
        if (format.type === 'document') {
          error = !(isValidCNPJ(field.value) || isValidCPF(field.value))
        }
        if (format.type === 'phone') {
          error = !isValidPhone(field.value)
        }
        if (format.type === 'credit_card') {
          error = !isValidCard(field.value)
        }
        if (format.type === 'expiration_date') {
          error = !isValidExpDate(field.value)
        }
        if (format.type === 'text') {
          error = /[^A-Za-z\s]+/g.test(field.value)
        }
      })
      return error ? 'format' : false
    }
  }

  return false
}
